var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mdl-textfield',{attrs:{"field-id":"signatureTyped","label":"Your Signature","bvalue":_vm.signature,"placeholder":"Type here to sign","show-chars-limit":true,"char-limit":"30","is-cursive":true},on:{"inputting":_vm.updateSignature}}),_vm._v(" "),_c('canvas',{attrs:{"id":"cvs","height":"50"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }